import { useEffect } from "react";

import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Textarea } from "@/app/global-components/textarea";

interface PersonelInfoProps {
  data: any;
  profileImage: File | null;
  coverImage: File | null;
  setStore: (store: any) => void;
  isEditMode: boolean;
  onEditModeChange: (isEditMode: boolean) => void;
  formData: StoreType;
  setFormData: (data: StoreType | ((prev: StoreType) => StoreType)) => void;
}

type StoreType = {
  name: string;
  email: string;
  website: string;
  commercialRegister: string;
  bioEn: string;
  bioAr: string;
};

function PersonelInfo({
  data,
  isEditMode,
  formData,
  setFormData,
}: PersonelInfoProps) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!isEditMode) return;
    const { name, value } = e.target;
    setFormData((prev: StoreType) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        email: data.email || "",
        website: data.website || "",
        commercialRegister: data.commercialRegister || "",
        bioEn: data.bioEn || "",
        bioAr: data.bioAr || "",
      });
    }
  }, [data, setFormData]);

  return (
    <div>
      <div className="grid grid-cols-2 gap-12">
        <div className="flex flex-col gap-2">
          <div>{t("company.fields.bio")} (en): </div>
          <Textarea
            name="bioEn"
            value={formData.bioEn}
            onChange={handleInputChange}
            disabled={!isEditMode}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>{t("company.fields.bio")} (ar): </div>
          <Textarea
            dir="rtl"
            name="bioAr"
            value={formData.bioAr}
            onChange={handleInputChange}
            disabled={!isEditMode}
          />
        </div>
      </div>
    </div>
  );
}

export default PersonelInfo;
